import ajax from "../utils/ajax";

export const ajaxSaveLog = (body) => {
  return ajax.post("/logger/", body);
};

export const sendSampleData = (payload) => {
  return ajax.post("/api/session-log/", payload);
};
